import React, { useState, useEffect } from 'react';
import { getExportedModels, getExportedModelDownloadUrl } from '../services/api';
import '../styles/ExportedModels.css';

const ExportedModels = () => {
  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingStates, setLoadingStates] = useState({});

  const fetchModels = async () => {
    const token = localStorage.getItem('adminToken');
    setLoading(true);
    try {
      const res = await getExportedModels(token);
      setModels(res.data.data || []);
    } catch (error) {
      console.error('Error fetching exported models:', error);
      alert('Failed to load exported models');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchModels();
  }, []);

  const handleDownload = async (model, fileType) => {
    const modelKey = `${model.models_id}_${model.version}_${fileType}`;
    setLoadingStates((prev) => ({
      ...prev,
      [modelKey]: true,
    }));

    const token = localStorage.getItem('adminToken');
    try {
      const res = await getExportedModelDownloadUrl(token, model.name, model.version, fileType);

      if (res.data.success) {
        const presignedUrl = res.data.data.url;
        const filename = res.data.data.filename;

        const link = document.createElement('a');
        link.href = presignedUrl;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        alert(res.data.message || 'Failed to get download URL');
      }
    } catch (error) {
      console.error(`Error downloading ${fileType}:`, error);
      alert(error.response?.data?.message || `Error downloading ${fileType}`);
    } finally {
      setLoadingStates((prev) => ({
        ...prev,
        [modelKey]: false,
      }));
    }
  };

  const downloadFileTypes = [
    { type: 'artifact', label: 'Artifact' },
    { type: 'model_card', label: 'Card' },
    { type: 'model_evaluation', label: 'Evaluation' },
    { type: 'training_dataset', label: 'Data' },
  ];

  return (
    <div className="exported-models-wrapper">
      <div className="exported-models-header">
        <h2>Exported Models</h2>
      </div>

      {loading ? (
        <div className="loading-message">Loading models...</div>
      ) : models.length === 0 ? (
        <div className="empty-message">No exported models found</div>
      ) : (
        <div className="exported-models-table-wrapper">
          <table className="exported-models-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Version</th>
                <th>Stage</th>
                <th>Big Data</th>
                <th>User</th>
                <th>Downloads</th>
              </tr>
            </thead>
            <tbody>
              {models.map((model) => {
                const modelKey = `${model.models_id}_${model.version}`;
                return (
                  <tr key={modelKey}>
                    <td className="model-name">{model.name}</td>
                    <td className="model-version">
                      <span className="version-badge">v{model.version}</span>
                    </td>
                    <td className="model-stage">
                      <span className="stage-badge">{model.stage}</span>
                    </td>
                    <td className="big-data-col">
                      {model.big_data ? (
                        <span className="badge-yes">Yes</span>
                      ) : (
                        <span className="badge-no">No</span>
                      )}
                    </td>
                    <td className="username-col">{model.username || 'Unknown'}</td>
                    <td className="downloads-col">
                      <div className="download-buttons">
                        {downloadFileTypes.map((fileType) => (
                          <button
                            key={fileType.type}
                            onClick={() => handleDownload(model, fileType.type)}
                            disabled={loadingStates[`${modelKey}_${fileType.type}`]}
                            className="download-btn"
                            title={`Download ${fileType.label}`}
                          >
                            {loadingStates[`${modelKey}_${fileType.type}`] ? '...' : fileType.label}
                          </button>
                        ))}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ExportedModels;
